import React, { useState, useMemo, createRef } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
// Providers
import { DashboardProvider } from '../Dashboard/useDashboard';
// Context
import useCallPerformanceContext from './context/useCallPerformanceContext';
// Components
import CallPerformanceTab from './components/CallPerformanceTab';
import Filter from './components/Filter';
// Modal
import PlottedMdsModal from './components/PlottedMdsModal';
import FvpModal from './components/FvpModal';
import CallRateModal from './components/CallRateModal';
import CallReachModal from './components/CallReachModal';
import CallConcentrationModal from './components/CallConcentrationModal';

export default function CallPerformanceDashboard() {
  const callPerformanceRef = createRef();
  const defaultFilterForm = {
    is_cpd: true,
    team: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    group: { label: 'ALL', value: null },
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
  };

  const [loading, setLoading] = useState(false);
  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [pmdsChart, setPmdsChart] = useState({
    total_percentage: 0,
    md_universe: 0,
    tagged_mds: 0,
    plotted_mds: 0,
  });

  const [fvpChart, setFvpChart] = useState({
    total_percentage: 0,
    frequency: 0,
    plotted: 0,
  });

  // const [pvaChart, setPvaChart] = useState({
  //   total_percentage: 0,
  //   target: 0,
  //   actual: 0,
  //   overdue: 0,
  //   due_soon: 0,
  // });

  const [callRateChart, setCallRateChart] = useState({
    total_percentage: 0,
    actual: 0,
    planned: 0,
    plotted: 0,
    retrieved: 0,
    advanced: 0,
    missed: 0,
  });

  const [callReachChart, setCallReachChart] = useState({
    total_percentage: 0,
    target: 0,
    reach: 0,
  });
  const [callConcentrationChart, setCallConcentrationChart] = useState({
    total_percentage: 0,
    target: 0,
    concentration: 0,
  });
  const [plottedMdsModal, setPlottedMdsModal] = useState(false);
  const [fvpModal, setFvpModal] = useState(false);
  const [callRateModal, setCallRateModal] = useState(false);
  const [callReachModal, setCallReachModal] = useState(false);
  const [callConcentrationModal, setCallConcentrationModal] = useState(false);

  const handleToggleModal = (modal) => {
    if (modal === 'plotted_mds') {
      setPlottedMdsModal(true);
    }

    if (modal === 'fvp') {
      setFvpModal(true);
    }

    if (modal === 'call_rate') {
      setCallRateModal(true);
    }

    if (modal === 'call_reach') {
      setCallReachModal(true);
    }

    if (modal === 'call_concentration') {
      setCallConcentrationModal(true);
    }
  };

  const handleGenerateFilter = () => {
    callPerformanceRef.current.handleGenerateFilter();
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilterForm);
    callPerformanceRef.current.handleClearFilter();
  };

  return (
    <DashboardProvider>
      <useCallPerformanceContext.Provider
        value={useMemo(
          () => ({
            // DATA
            loading,
            filterForm,
            defaultFilterForm,
            pmdsChart,
            fvpChart,
            callRateChart,
            callReachChart,
            callConcentrationChart,
            plottedMdsModal,
            fvpModal,
            callRateModal,
            callReachModal,
            callConcentrationModal,
            // STATE
            setLoading,
            setFilterForm,
            setPmdsChart,
            setFvpChart,
            setCallRateChart,
            setCallReachChart,
            setCallConcentrationChart,
            setPlottedMdsModal,
            setFvpModal,
            setCallRateModal,
            setCallReachModal,
            setCallConcentrationModal,
            // FUNCTION
            handleToggleModal,
            handleGenerateFilter,
            handleClearFilter,
          }),
          [
            filterForm,
            pmdsChart,
            fvpChart,
            callRateChart,
            callReachChart,
            callConcentrationChart,
            plottedMdsModal,
            fvpModal,
            callRateModal,
            callReachModal,
            callConcentrationModal,
          ],
        )}
      >
        <Box>
          <Filter />
        </Box>
        <Box mt={5}>
          <CallPerformanceTab ref={callPerformanceRef} />
        </Box>
        {plottedMdsModal ? <PlottedMdsModal /> : null}
        {fvpModal ? <FvpModal /> : null}
        {callRateModal ? <CallRateModal /> : null}
        {callReachModal ? <CallReachModal /> : null}
        {callConcentrationModal ? <CallConcentrationModal /> : null}
      </useCallPerformanceContext.Provider>
    </DashboardProvider>
  );
}
